<template>
  <div class="videoPlayer">
    <div class="videoBox">
      <video
        ref="curVideo"
        class="video"
        width="100%"
        controls="controls"
        :src="videoUrl"
        :autoplay="autoplay"
        muted
        preload="metadata"
      ></video>
      <div class="watermark">
        {{ watermark }}
      </div>
      <!-- <div class="el-loading-mask" style="">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle
              cx="50"
              cy="50"
              r="20"
              fill="none"
              class="path"
            ></circle></svg
          >
        </div>
      </div> -->
    </div>
    <div class="episode">
      <div class="title">{{ title }}</div>
      <div class="nums">
        <span
          v-for="item in nums"
          :key="item"
          :class="curNum === item ? 'selected' : ''"
          @click="numsClick(item)"
        >
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoPlayer",
  props: {
    baseUrl: {
      type: String,
      required: true,
      default: "",
    },
    videoUrl: {
      type: String,
      required: true,
      default: "",
    },
    title: {
      type: String,
      required: true,
      default: "",
    },
    setNum: {
      type: Number,
      required: true,
      default: 40,
    },
    videoFormat: {
      type: String,
      default: "mp4",
    },
    num: {
      type: String,
      default: "1",
    },
    watermark: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curNum: '1',
      videoHeight: '700px'
    }
  },
  computed: {
    nums: function () {
      let data = [];
      for (let i = 1; i <= this.setNum; i++) {
        if (i < 10 && this.num==='01') data.push("0" + i);
        else data.push("" + i);
      }
      return data;
    },
  },
  mounted() {
    this.getVideoInfo();
  },
  methods: {
    numsClick(num) {
      this.curNum = num;
      this.videoUrl = `${this.baseUrl}${num}.${this.videoFormat}`;
      const _this = this;
      // 轮询视频时长，得到时长后清除定时器
      let hasDuration = setInterval(() => {
        let curVideoDuration = _this.$refs["curVideo"].duration;
        if (curVideoDuration) {
          // console.log("curVideoDuration", curVideoDuration);
          clearInterval(hasDuration);
        }
      }, 10);
    },
    getVideoInfo() {
      const _this = this;
      setTimeout(() => {
        var box = document.getElementsByClassName("video");
        var videoH = box[0].clientHeight;
        _this.videoHeight = videoH + "px";
      }, 1000);
      window.onresize = function () {
        var box = document.getElementsByClassName("video");
        var videoH = box[0].clientHeight;
        _this.videoHeight = videoH + "px";
        console.log(_this.videoHeight);
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.videoPlayer {
  width: 100%;
  position: relative;
  display: flex;
  .videoBox {
    flex: 1;
    margin-right: 10px;
    position: relative;
    .video {
      height: 100%;
      width: 100%;
      display: block;
      object-fit: fill;
    }
    .watermark{
      color: #fff;
      position: absolute;
      right: 15px;
      bottom: 65px;
      z-index: 99;
    }
  }
  .episode {
    overflow: scroll;
    width: 440px;
    padding: 20px;
    background-color: #222328;
    border-radius: 4px;
    .title {
      display: block;
      color: hsla(0, 0%, 100%, 0.9);
      line-height: 44px;
      font-size: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .nums {
      margin-top: 20px;
      margin-bottom: 14px;
      span {
        position: relative;
        float: left;
        width: 56px;
        height: 44px;
        line-height: 44px;
        border-radius: 4px;
        color: #ccc;
        font-size: 15px;
        font-family: Arial, PingFang SC, Microsoft Yahei;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s;
      }
      .selected,
      :hover {
        background-color: #1d2129;
        color: #00cc4c;
      }
    }
  }
}
</style>